import { useEffect, useRef } from 'react'
import Explanation from './Explanation'
import Actions from './Actions'
import Button from '../../../../Button'
import './index.css'
import { FaCheck } from 'react-icons/fa'
import { IoCloseSharp } from 'react-icons/io5'
import { formatExplanation } from '../../../../../utils'

const FooterAfterResponse = ({
  createGrid,
  currentGrila,
  isActive,
  handleUpdateGrid,
  explanation,
  pages,
  book,
  books,
  isCorrect,
  handleRate,
  rated,
  solvingTimePercent,
  isSubmitted,
  isSubject,
  handleNextGrid,
  handlePrevGrid,
  subjectLength,
  currentGridIndex,
  setRated,
  handleNewSubjectWindow,
  setHeight,
  isCreateSubject,
  isPartialyCorrect,
}) => {
  const containerRef = useRef(null)
  useEffect(() => {
    if (containerRef?.current && createGrid ? currentGrila : explanation) {
      setHeight(containerRef?.current?.clientHeight)
    } else {
      setHeight(0)
    }
  }, [containerRef, explanation, currentGrila, createGrid, setHeight])

  return explanation ? (
    <div
      ref={containerRef}
      className={`w-full explanation-container h-[200px] md:!h-[150px] flex-col lg:flex-row flex pl-1 pr-1 md:pl-[15px] md:pr-[15px] lg:items-center justify-center items-center transform absolute rounded-bl rounded-br bottom-[0px] z-[101] 
      ${isSubmitted ? 'fade-in' : ''} ${
        isCorrect === null
          ? 'text-white'
          : isCorrect === false
            ? isPartialyCorrect === false
              ? 'bg-error'
              : 'bg-partially-correct'
            : 'bg-correct'
      }  ${isActive ? 'transform translate-y-[0] ' : 'translate-y-[100%]'} 
      }`}
    >
      {isCorrect ? (
        <FaCheck className="hidden md:flex bg-correct z-[1000] fixed text-white w-[35px] h-[35px] left-[-15px] top-[-15px] rounded-full md:top-[-30px] md:left-[-30px] border-2 border-white md:w-[50px] md:h-[50px] p-[10px]" />
      ) : (
        <IoCloseSharp
          className={`${
            isPartialyCorrect ? 'bg-partially-correct' : 'bg-error'
          } hidden md:flex z-[1000] fixed text-white w-[35px] h-[35px] left-[-15px] top-[-15px]  rounded-full md:top-[-30px] md:left-[-30px] border-2 border-white md:w-[50px] md:h-[50px] p-[10px]`}
        />
      )}
      <Explanation
        explanation={
          formatExplanation(explanation, books, book) ||
          'Această grilă nu are încă explicație'
        }
      />
      {!createGrid ? (
        <Actions
          isCreateSubject={isCreateSubject}
          handleNewSubjectWindow={handleNewSubjectWindow}
          setRated={setRated}
          subjectLength={subjectLength}
          currentGridIndex={currentGridIndex}
          handleNextGrid={handleNextGrid}
          handlePrevGrid={handlePrevGrid}
          isSubject={isSubject}
          isCorrect={isCorrect}
          solvingTimePercent={solvingTimePercent}
          disabled={rated}
          handleRate={handleRate}
          handleUpdateGrid={handleUpdateGrid}
        />
      ) : null}
    </div>
  ) : null
}

export default FooterAfterResponse
